import type { useAppInitialization } from "../hooks/useAppInitialization";

export const getRetailerRouteAccess = ({
  firebase,
  sellar,
  currentBusiness,
  remoteFeatureFlags,
}: Pick<
  ReturnType<typeof useAppInitialization>,
  "firebase" | "sellar" | "currentBusiness" | "remoteFeatureFlags"
>): "loading" | "allowed" | "denied" => {
  if (
    firebase.loading ||
    sellar.loading ||
    currentBusiness.loading ||
    remoteFeatureFlags.isLoading
  ) {
    return "loading";
  }

  const { business } = currentBusiness;
  const isAllowed =
    firebase.user &&
    sellar.user &&
    business?.type === "retailer" &&
    business.Retailer?.id &&
    remoteFeatureFlags.isActive("retailerNavigation");

  return isAllowed ? "allowed" : "denied";
};
